var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 39C16.2261 39 11.6477 37.1036 8.27208 33.7279C4.89642 30.3523 3 25.7739 3 21C3 16.2261 4.89642 11.6477 8.27208 8.27208C11.6477 4.89642 16.2261 3 21 3V39ZM26.739 7.146C28.5577 7.90033 30.2101 9.00534 31.602 10.398L33.72 8.28C32.05 6.60866 30.0673 5.28244 27.885 4.377L26.739 7.146ZM39 21C39.0018 18.6366 38.5343 16.2963 37.6245 14.115L34.854 15.261C35.6129 17.079 36.0025 19.0299 36 21H39ZM41.07 42H30.927L36 31.854L41.07 42ZM36 27C35.7213 26.9999 35.448 27.0774 35.2108 27.2239C34.9737 27.3705 34.7821 27.5802 34.6575 27.8295L27.1575 42.8295C27.0432 43.0582 26.9893 43.3124 27.0008 43.5679C27.0124 43.8233 27.0891 44.0716 27.2236 44.289C27.3581 44.5065 27.546 44.686 27.7694 44.8104C27.9928 44.9349 28.2443 45.0001 28.5 45H43.5C43.7477 45 43.9916 44.9387 44.2098 44.8216C44.4281 44.7044 44.6139 44.535 44.7507 44.3285C44.8875 44.122 44.9711 43.8849 44.9939 43.6382C45.0167 43.3916 44.9781 43.1431 44.8815 42.915L37.3425 27.8295C37.2179 27.5802 37.0263 27.3705 36.7892 27.2239C36.552 27.0774 36.2787 26.9999 36 27Z",
    fill: "#b1cffe7f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.037aebeffea485902105b8d9e84485f1.svg";
export { ForwardRef as ReactComponent };